import React from "react";
import BreadcrumbArea from "../components/BreadcrumbArea/BreadcrumbArea";
import InnerContactArea from "../components/Contact/InnerContactArea";
import Layout from "../layouts/Layout";
import { Helmet } from "react-helmet";

const ContactPage = () => {
  return (
    <Layout header={1} footer={3} className="" mainClassName="">
      <Helmet>
        <title>Contact | Vernu Stoffering</title>
        <meta
          name="description"
          content="Neem contact op met Vernu Stoffering in Rotterdam voor al uw vragen, stofferingen en afspraken. Gevestigd aan de Abtsweg 41A - 43A."
        />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Contact | Vernu Stoffering Rotterdam" />
        <meta
          property="og:description"
          content="Bezoek ons of neem contact op voor Stofferingen. Snel, professioneel en persoonlijk geholpen in Rotterdam en heel Nederland."
        />
      </Helmet>

      <BreadcrumbArea
        title={"Contact"}
        subtitle={"Contact"}
        className={"breadcrumb-area-four pt-175 pb-160"}
        showShape={false}
        showShapeThree={true}
      />

      <InnerContactArea />
    </Layout>
  );
};

export default ContactPage;
